<template>
  <el-dialog
      v-el-drag-dialog
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      title="详情"
      width="800px"
      top="3vh"
      @close="params = {}, filter = {}">
    <el-tabs v-model="activeName">
      <el-tab-pane label="逾期" name="first">
        <vm-table
            ref="vmTable"
            :filter.sync="filter"
            module="basic"
            :url="url">
          <template slot="adSearch">
            <div class="vm-search">
              <vm-search label="查找">
                <el-input v-model.trim="filter.filter" clearable/>
              </vm-search>
            </div>
          </template>
          <el-table-column prop="deliveryBillNO" label="发货单号"/>
          <el-table-column prop="salesOrderNO" label="订单号"/>
          <el-table-column prop="sapSalesOrderNO" label="sap订单号"/>
          <el-table-column prop="salesOrderDeliveryDate" label="订单交期"/>
          <el-table-column prop="deliveryDate" label="发货日期"/>
        </vm-table>
      </el-tab-pane>
      <el-tab-pane label="所有" name="second">
        <vm-table
            ref="vmTable2"
            :filter.sync="filter2"
            module="basic"
            :url="url2">
          <template slot="adSearch">
            <div class="vm-search">
              <vm-search label="查找">
                <el-input v-model.trim="filter2.filter" clearable/>
              </vm-search>
            </div>
          </template>
          <el-table-column prop="deliveryBillNO" label="发货单号"/>
          <el-table-column prop="salesOrderNO" label="订单号"/>
          <el-table-column prop="sapSalesOrderNO" label="sap订单号"/>
          <el-table-column prop="salesOrderDeliveryDate" label="订单交期"/>
          <el-table-column prop="deliveryDate" label="发货日期"/>
        </vm-table>
      </el-tab-pane>
    </el-tabs>
  </el-dialog>
</template>

<script>
  import VmTable from "@/components/VmTable.vue";
  import VmSearch from "@/components/VmSearch.vue";

  export default {
    components: {VmTable, VmSearch},
    data() {
      return {
        dialogVisible: false,
        activeName: "first",
        params: {
          date: null,
          month: null,
        },
        filter: {
          filter: "",
        },
        url: "",
        params2: {
          date: null,
          month: null,
        },
        filter2: {
          filter: "",
        },
        url2: "",
      };
    },
    methods: {
      open(filter) {
        this.dialogVisible = true;
        if (filter.length === 10) {
          this.params.date = filter;
          this.params2.date = filter;
          this.url = "sAPShipmentInvoices/date/" + filter;
          this.url2 = "sAPShipmentInvoices/dateExpect/" + filter;
        } else {
          this.params.month = filter;
          this.params2.month = filter;
          this.url = "sAPShipmentInvoices/month/" + filter;
          this.url2 = "sAPShipmentInvoices/monthExpect/" + filter;
        }
        this.$nextTick(() => {
          this.$refs.vmTable.getList();
          this.$refs.vmTable2.getList();
        });
      },
    },
  };
</script>

<style lang="scss" scoped>
</style>
